import { Routes } from '@angular/router';
import { SuiviDeclarationsComponent } from './suivi-declarations.component';

export const SUIVI_DECLARATIONS_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'liste',
        pathMatch: 'full',
        data: {
            role: 'ORGANISME',
            menu: { icon: 'wine-bottle', libelle: 'menu.suivi-declarations', hide: true }
        }
    },
    {
        path: 'liste',
        component: SuiviDeclarationsComponent
    }
];
